import { memo, useMemo } from 'react';
import {
  Badge,
  useMantineTheme,
  useComputedColorScheme,
  Text,
} from '@mantine/core';

interface TariffBadgeProps {
  code: string;
  prefix: number;
  type: string;
}

export const TariffBadge: React.FC<TariffBadgeProps> = memo(
  ({ code, prefix, type }) => {
    const theme = useMantineTheme();
    const computedColorScheme = useComputedColorScheme('dark');
    const color = useMemo(() => {
      return type === 'Base'
        ? theme.colors[`secondary-${computedColorScheme}`][0]
        : theme.colors[`tariff-modifier-${computedColorScheme}`][0];
    }, [theme, computedColorScheme]);

    return (
      <Badge
        variant="filled"
        color={color}
        c={computedColorScheme === 'dark' ? theme.colors.dark[9] : 'white'}
        autoContrast
        size="md"
        radius="sm"
      >
        <Text inherit fw={700} size="sm">{`${prefix}${code}`}</Text>
      </Badge>
    );
  }
);
